// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__5rmrd","alertIcon":"ConfirmModal_alertIcon__DEIWR"};